import React from 'react';
import { createPortal } from 'react-dom';
import './AttachDocumentModal.css';

/**
 * A small choice modal shown when the user clicks the "+" attach button.
 * Offers two options: upload a new document or select from existing ones.
 */
const AttachDocumentModal = ({ isOpen, onClose, onUploadNew, onSelectExisting }) => {
  React.useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return createPortal(
    <div className="attach-modal-overlay" onClick={handleOverlayClick}>
      <div className="attach-modal" onClick={(e) => e.stopPropagation()}>
        <div className="attach-modal__header">
          <h3 className="attach-modal__title">Add Document</h3>
          <button className="attach-modal__close" onClick={onClose} title="Close" aria-label="Close">✕</button>
        </div>
        <div className="attach-modal__body">
          <button
            className="attach-modal__option"
            onClick={() => { onClose(); onUploadNew(); }}
          >
            <span className="attach-modal__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
            <span className="attach-modal__label">
              <strong>Upload New Document</strong>
              <span className="attach-modal__desc">Upload a file from your device</span>
            </span>
          </button>

          <button
            className="attach-modal__option"
            onClick={() => { onClose(); onSelectExisting(); }}
          >
            <span className="attach-modal__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="14 2 14 8 20 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="10 9 9 9 8 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
            <span className="attach-modal__label">
              <strong>Select Existing Document</strong>
              <span className="attach-modal__desc">Choose from your uploaded documents</span>
            </span>
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AttachDocumentModal;
